/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { CommonModule } from "@angular/common";
import {
  Component,
  OnInit,
  OnDestroy,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from "@angular/core";
import { ButtonModule } from "primeng/button";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { SkeletonModule } from "primeng/skeleton";
import { AccordionModule } from "primeng/accordion";
import { TagModule } from "primeng/tag";
import { TooltipModule } from "primeng/tooltip";
import { SplitterModule } from "primeng/splitter";
import { TabsModule } from "primeng/tabs";
import { TerminalModule } from "primeng/terminal";
import { StepsModule } from "primeng/steps";
import { BadgeModule } from "primeng/badge";
import { TimelineModule } from "primeng/timeline";

import {
  QPilotService,
  QPilotAccessToken,
} from "../../../../core/services/qpilot.service";
import { SessionService } from "../../../../core/services/session.service";
import { TimezoneHelper } from "../../../../core/utils/timezone.helper";
import { Site } from "../../../../core/models/site.interface";

export interface ProcessingCycleLogsDialogData {
  scheduledOrderId: number;
  siteId: number;
  processingCycleId: number;
  processingCycle: any;
  accessToken?: QPilotAccessToken; // Optional access token for embedded mode
}

// Matches old QMC QPilotProcessingLog exactly
export interface QPilotProcessingLog {
  Id: number;
  CreatedUtc: Date;
  Type: string;
  Description: string;
  ProcessingCycleId: number;
  ProcessingCycle?: any;
}

// Matches old QMC QPilotProcessingStage exactly
export interface QPilotProcessingStage {
  Stage: string;
  Status: string;
}

// Matches old QMC QPilotProcessingCycleLogsByAttempt exactly
export interface QPilotProcessingCycleLogsByAttempt {
  ProcessingCycleLogsByAttempt: Record<string, QPilotProcessingLog[]>;
  ProcessingCycleStagesByAttempt: Record<string, QPilotProcessingStage[]>;
}

/**
 * Processing Cycle Logs Dialog Component
 * Shows detailed processing logs for a specific processing cycle (matches old QMC ScheduledOrderLogsDialogComponent)
 */
@Component({
  selector: "app-processing-cycle-logs-dialog",
  standalone: true,
  imports: [
    CommonModule,
    ButtonModule,
    SkeletonModule,
    AccordionModule,
    TagModule,
    TooltipModule,
    SplitterModule,
    TabsModule,
    TerminalModule,
    StepsModule,
    BadgeModule,
    TimelineModule,
  ],
  templateUrl: "./processing-cycle-logs-dialog.component.html",
  styleUrl: "./processing-cycle-logs-dialog.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProcessingCycleLogsDialogComponent implements OnInit, OnDestroy {
  processingCycleAttempts: string[] = [];
  processingCycleLogsByAttempt: Record<string, QPilotProcessingLog[]> = {};
  processingCycleStagesByAttempt: Record<string, QPilotProcessingStage[]> = {};

  selectedProcessingCycleAttempt: string = "";
  activeTabIndex: number = 0;
  isLoading = false;
  site: Site | null = null;
  timer: any;

  // Pre-generated random widths for skeleton loading (prevents ExpressionChangedAfterItHasBeenCheckedError)
  skeletonWidths: string[] = [
    "85%",
    "92%",
    "78%",
    "88%",
    "95%",
    "82%",
    "90%",
    "88%",
  ];

  // Cached reversed attempts to avoid recalculating on every change detection
  reversedAttempts: string[] = [];

  get processingCycle() {
    return this.config.data?.processingCycle;
  }

  constructor(
    private qpilotService: QPilotService,
    private sessionService: SessionService,
    private timezoneHelper: TimezoneHelper,
    private cdr: ChangeDetectorRef,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig<ProcessingCycleLogsDialogData>,
  ) {}

  ngOnInit(): void {
    this.loadHistory();

    // If processing cycle is still processing, poll for updates every 2 seconds
    if (this.processingCycle?.Status === "Processing") {
      this.timer = setInterval(() => {
        this.loadHistory(false);
      }, 2000);
    }
  }

  ngOnDestroy(): void {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  /**
   * Get access token from config or session
   */
  private getAccessToken() {
    return this.config.data?.accessToken ?? this.sessionService.accessToken;
  }

  /**
   * Load processing logs and history
   */
  private loadHistory(showLoading = true): void {
    const accessToken = this.getAccessToken();
    if (
      !this.config.data?.processingCycleId ||
      !this.config.data?.siteId ||
      !accessToken
    ) {
      return;
    }

    this.isLoading = showLoading;

    // Load site data for timezone calculations
    this.qpilotService.getSite(this.config.data.siteId, accessToken).subscribe({
      next: (site) => {
        this.site = site as Site;
        this.cdr.markForCheck(); // Trigger change detection with OnPush
      },
      error: (error) => {
        console.error("Failed to load site data:", error);
      },
    });

    // Load processing logs - matches old QMC exactly
    this.qpilotService
      .getProcessingLogs(
        accessToken,
        this.config.data.siteId,
        this.config.data.processingCycleId,
      )
      .subscribe({
        next: (result: QPilotProcessingCycleLogsByAttempt) => {
          this.processingCycleAttempts = Object.keys(
            result.ProcessingCycleLogsByAttempt,
          );
          this.processingCycleLogsByAttempt =
            result.ProcessingCycleLogsByAttempt;
          this.processingCycleStagesByAttempt =
            result.ProcessingCycleStagesByAttempt;

          // Cache reversed attempts to avoid recalculating on every change detection
          this.reversedAttempts = [...this.processingCycleAttempts].reverse();

          // Select the first (latest) attempt by default - matches old QMC
          if (this.processingCycleAttempts.length > 0) {
            this.selectedProcessingCycleAttempt =
              this.processingCycleAttempts[0];
          }

          this.isLoading = false;
          this.cdr.markForCheck(); // Trigger change detection with OnPush
        },
        error: (error) => {
          console.log(error); // Match old QMC console.log instead of console.error
          this.isLoading = false;
          this.cdr.markForCheck(); // Trigger change detection with OnPush
        },
      });
  }

  /**
   * Handle tab change and set the selected processing attempt
   */
  onTabChange(index: number): void {
    const attempt = this.reversedAttempts[index];
    if (attempt) {
      this.selectedProcessingCycleAttempt = attempt;
    }
  }

  /**
   * Get log status description - matches old QMC logic
   */
  getLogStatusDescription(status: string): string {
    switch (status) {
      case "ProcessingError":
        return "Error";
      case "ProcessingStart":
        return "Scheduled Start";
      case "ProcessingStartManualRetry":
        return "Manual Start";
      case "ProcessingStartAutomaticRetry":
        return "Automatic Retry";
      default:
        return status;
    }
  }

  /**
   * Get stage status icon
   */
  getStageStatusIcon(status: string): string {
    switch (status) {
      case "Success":
        return "pi pi-check-circle";
      case "Failed":
        return "pi pi-times-circle";
      case "Queued":
        return "pi pi-clock";
      default:
        return "pi pi-question-circle";
    }
  }

  /**
   * Get stage status severity
   */
  getStageStatusSeverity(
    status: string,
  ): "success" | "info" | "warning" | "danger" {
    switch (status) {
      case "Success":
        return "success";
      case "Failed":
        return "danger";
      case "Queued":
        return "info";
      default:
        return "info";
    }
  }

  /**
   * Format date with site timezone (includes GMT offset like old QMC)
   */
  formatDate(date: Date | string): string {
    if (!date) return "-";
    const dateObj = typeof date === "string" ? new Date(date) : date;
    const utcOffset = this.site?.UtcOffset ?? 0;
    const formattedDate = this.timezoneHelper.formatDateWithTimezone(
      dateObj,
      utcOffset,
    );
    const gmtOffset = this.timezoneHelper.formatGmtOffset(utcOffset);
    return `${formattedDate} ${gmtOffset}`;
  }

  /**
   * Close the dialog
   */
  onClose(): void {
    this.ref.close();
  }

  /**
   * Track by function for ngFor performance
   */
  trackByAttempt(index: number, attempt: string): string {
    return attempt;
  }

  /**
   * Track by function for logs ngFor performance
   */
  trackByLogIndex(index: number, log: QPilotProcessingLog): number {
    return log.Id || index;
  }

  /**
   * Track by function for stages ngFor performance
   */
  trackByStageIndex(index: number, stage: QPilotProcessingStage): number {
    return index;
  }

  /**
   * Get reversed array for ngFor (latest first)
   * Returns cached value to avoid recalculating on every change detection
   */
  getReversedAttempts(): string[] {
    return this.reversedAttempts;
  }

  /**
   * Get steps data for PrimeNG Steps component
   */
  getStepsForAttempt(attempt: string): any[] {
    const stages = this.processingCycleStagesByAttempt[attempt] || [];
    return stages.map((stage, index) => ({
      label: stage.Stage,
      styleClass: this.getStageStatusClass(stage.Status),
      command: () => {},
    }));
  }

  /**
   * Get stage status class for styling
   */
  getStageStatusClass(status: string): string {
    switch (status) {
      case "Success":
        return "step-success";
      case "Failed":
        return "step-failed";
      case "Queued":
        return "step-queued";
      default:
        return "step-unknown";
    }
  }

  /**
   * Get formatted logs for terminal-style display
   */
  getFormattedLogsForAttempt(attempt: string): string {
    const logs = this.processingCycleLogsByAttempt[attempt] || [];
    return logs
      .map((log) => {
        const timestamp = this.formatDate(log.CreatedUtc);
        return `${timestamp} ${log.Description}`;
      })
      .join("\n");
  }

  /**
   * Get attempt badge severity
   */
  getAttemptBadgeSeverity(
    attempt: string,
  ): "success" | "info" | "warn" | "danger" | "secondary" | "contrast" {
    const stages = this.processingCycleStagesByAttempt[attempt] || [];
    const hasFailure = stages.some((stage) => stage.Status === "Failed");
    const hasSuccess = stages.some((stage) => stage.Status === "Success");

    if (hasFailure) return "danger";
    if (hasSuccess) return "success";
    return "info";
  }

  /**
   * Format stage name with proper spacing (e.g., "PreProcessing" -> "Pre Processing")
   */
  formatStageName(stageName: string): string {
    if (!stageName) return "";
    // Add space before capital letters (except the first one)
    return stageName.replace(/([a-z])([A-Z])/g, "$1 $2");
  }

  /**
   * Get pre-generated width for skeleton log lines (for visual variety)
   * Uses index to return a consistent width value, avoiding ExpressionChangedAfterItHasBeenCheckedError
   */
  getSkeletonWidth(index: number): string {
    return this.skeletonWidths[index % this.skeletonWidths.length];
  }
}
